<template>
    <div>
        <Language v-model="form.lang" @change="handleLangChange"></Language>
        <el-form ref="form" label-width="100px">
            <el-form-item label="视频标题" prop="name">
                {{ form.name }}
            </el-form-item>
            <el-form-item label="seo关键词" prop="keyword">
                <span v-for="(item, index) in keyword" :key="index">{{ item }}</span>
            </el-form-item>
            <el-form-item label="副标题" prop="sub_name">
                {{ form.sub_name }}
            </el-form-item>
            <el-form-item label="选择分类" prop="category_uuid">
                {{ form.category.name }}
            </el-form-item>
            <el-form-item label="视频描述" prop="desc">
                {{ form.desc }}
            </el-form-item>
            <el-form-item label="上传视频" prop="url">
                <Uploader type="video" disabled v-model="form.url"></Uploader>
            </el-form-item>
            <el-form-item>
                <el-button style="width: 120px" @click="$router.back()">返回</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Language from "@/components/Language";
import Uploader from "@/components/Uploader";
import { detail } from "@/api/video/list";
export default {
    components: { Language, Uploader },
    data() {
        return {
            form: {
                lang: "zh",
                category: {},
            },
            keyword: [],
        };
    },
    mounted() {
        this.form.cuuid = this.$route.query.cuuid;
        this.getDetail();
    },
    methods: {
        handleLangChange() {
            this.getDetail();
        },
        getDetail() {
            detail({ cuuid: this.form.cuuid, lang: this.form.lang }).then(({ code, result, error }) => {
                if (code === 200) {
                    if (result) {
                        this.form = { ...result };
                        this.form.keyword = result.keyword ? result.keyword.split(",") : [];
                        this.keyword = this.form.keyword;
                    } else {
                        this.form = { lang: this.form.lang, cuuid: this.form.cuuid, category: {}, keyword: [] };
                        this.keyword = [];
                    }
                } else {
                    this.$message.error(error.message);
                }
            });
        },
    },
};
</script>

<style></style>
